"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListItemOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            paddingTop: spacing(5),
            paddingBottom: spacing(5),
        },
        dense: {
            paddingTop: spacing(3),
            paddingBottom: spacing(3),
        },
        gutters: {
            paddingLeft: spacing(4),
            paddingRight: spacing(4),
        },
        secondaryAction: {
            paddingRight: spacing(12),
        },
    });
};
//# sourceMappingURL=MuiListItem.js.map